import { render, staticRenderFns } from "./QuestionsManager.vue?vue&type=template&id=2bced93a&scoped=true"
import script from "./QuestionsManager.vue?vue&type=script&lang=js"
export * from "./QuestionsManager.vue?vue&type=script&lang=js"
import style0 from "./QuestionsManager.vue?vue&type=style&index=0&id=2bced93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bced93a",
  null
  
)

export default component.exports